export default {"src":"/_next/static/media/acko-logo.4246ae7c.svg","height":36,"width":113,"blurWidth":0,"blurHeight":0};